
<div class="container d-flex align-items-center p-5" *ngIf="loading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>
<div class="container w-100" *ngIf="!loading">
    <div class="row mat-elevation-z2 rounded mt-5 p-2">
        <h1 class="text-bold mb-0">Get Started</h1>
        <p class="text-muted">Create your voice assistant in three steps: configure, prompt, deploy - Begin by selecting
            your assistant type.</p>

        <h3 class="mt-3 text-dark text-bold">Choose your type of assistant</h3>
        <div class="row justify-content-around">

            <div class="col-12 col-sm-12 col-md-5 col-lg-5 border rounded p-3">
                <mat-icon class="w-auto h-auto" style="font-size: xx-large;">north_east</mat-icon>
                <h2 class="text-bold mb-0">Outbound</h2>
                <p>Automate calls within workflows using Zapier and our custom flow builder.</p>
                <button (click)="onOutboundClick()" mat-raised-button class="mx-auto d-block mt-4" [ngStyle]="{'width': (isHandset$ | async) ? '80%' : '25%'}">Select</button>
            </div>

            <div class="col-12 col-sm-12 col-md-5 col-lg-5 border rounded p-3">
                <mat-icon class="w-auto h-auto" style="font-size: xx-large;">south_west</mat-icon>
                <h2 class="text-bold mb-0">Inbound</h2>
                <p>Manage incoming calls via phone, Zapier or Cal.</p>
                <button (click)="onInboundClick()" mat-raised-button class="mx-auto d-block mt-4" [ngStyle]="{'width': (isHandset$ | async) ? '80%' : '25%'}">Select</button>
            </div>
        </div>
    </div>
</div>